<template>
  <div>
    <div
      v-if="questionnaires"
      class="tw-flex tw-gap-5 tw-mb-3 tw-px-6"
    >
      <div class="tw-flex-1 tw-text-gray-dark dark:tw-text-dm-gray-dark tw-leading-5">
        {{ $t('quest.quest_type') }}
      </div>
      <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-w-40 tw-leading-5">
        {{ $t('common.filters.status') }}
      </div>
      <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-w-32 tw-leading-5">
        {{ $t('quest.submitted') }}
      </div>
      <div
        v-if="$isInRole(['ADMIN', 'CONSULTANT'])"
        class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-w-40 tw-leading-5"
      >
        {{ $t('common.fields.actions') }}
      </div>
    </div>

    <div>
      <ForeignersQuestionnairesListItem
        v-for="questionnaire in questionnaires"
        :key="questionnaire.id"
        :questionnaire="questionnaire"
      />
    </div>
  </div>
</template>

<script>
import ForeignersQuestionnairesListItem
  from '@/components/Foreigners/Questionnaires/ForeignersQuestionnairesListItem.vue';
import { mapState } from 'vuex';

export default {
  name: 'ForeignersQuestionnairesList',
  components: {
    ForeignersQuestionnairesListItem,
  },

  computed: {
    ...mapState({
      foreigner: (state) => state.v2.admin.foreigners.foreigner.foreigner,
      questionnaires: (state) => state.v2.admin.foreigners.foreigner.questionnaires,
    }),
  },

  mounted() {
    this.$store.dispatch('v2/admin/foreigners/foreigner/loadQuestionnaires', this.foreigner.id);
  },
};
</script>
